module.exports = {"libs.constants.noticeMessage.noticeShowContact":"Si vous continuez à voir cette erreur, contactez-nous à https://choosemuse.com/contactsupport","libs.constants.noticeMessage.general":"Désolé, une erreur s'est produite. Veuillez réessayer.","libs.constants.sessionTimeout.notificationMessage":"Vous avez été déconnecté de votre session en raison de l'inactivité. Veuillez vous connecter à votre compte pour continuer votre session.","libs.constants.auth.notificationMessage":"Vous devez d'abord vous connecter"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/fr/libs/constants.json
// module id = 802
// module chunks = 0